import React, { useContext, useEffect, useState } from 'react'
import PaginationButtons from '../PaginationButtons'
import LoginContext from '../../context';
const RecommendTable = () => {
    const { token } = useContext(LoginContext)
    const [directReferals, setDirectReferals] = useState([]);
    const [loading, setLoading] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const pageSize = 15;

    const fetchDirectReferals = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/referrals/users?&page=${currentPage}&size=${pageSize}`, {
                headers: {
                    'Accept': 'application/json',
                    Authorization: `Bearer ${token.token}`,
                }
            });
            const data = await response.json();
            setDirectReferals(data.results);
            setTotalPages(data.total_pages);
            // console.log(data)
        } catch (error) {
            console.error('Error fetching messages:', error);
        }
    }
    useEffect(() => {
        fetchDirectReferals();
    }, [currentPage,]);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };
    return (
        <>
            <table width="100%" cellpadding="0" cellspacing="0" className="bbs-list-cash topth ">
                <colgroup>
                    <col className='w-auto lg:w-[4%]' />
                    <col className='w-auto lg:w-[26%]' />
                    <col className='w-auto lg:w-[25px]' />
                    <col className='w-auto lg:w-[20%]' />
                    <col className='w-auto lg:w-[25%]' />
                </colgroup>
                <tbody>
                    <tr>
                        <th align="center" className='hidden lg:table-cell font-sans-serif lg:font-NotoSansKR  h-[35px] lg:h-[33px] text-center font-medium text-xs lg:text-[13px] text-white border-t-steel border-b-graphite border-b border-t-2 bg-graphite'><strong>no</strong></th>
                        <th align="center" className='font-sans-serif lg:font-NotoSansKR  h-[35px] lg:h-[33px] text-center font-medium text-xs lg:text-[13px] text-white border-t-steel border-b-graphite border-b border-t-2 bg-graphite'><strong>추천인 아이디</strong></th>
                        <th align="center" className='font-sans-serif lg:font-NotoSansKR  h-[35px] lg:h-[33px] text-center font-medium text-xs lg:text-[13px] text-white border-t-steel border-b-graphite border-b border-t-2 bg-graphite'><strong>추천인 닉네임</strong></th>
                        <th align="center" className='font-sans-serif lg:font-NotoSansKR  h-[35px] lg:h-[33px] text-center font-medium text-xs lg:text-[13px] text-white border-t-steel border-b-graphite border-b border-t-2 bg-graphite'><strong>회원구분</strong></th>
                        <th align="center" className='font-sans-serif lg:font-NotoSansKR  h-[35px] lg:h-[33px] text-center font-medium text-xs lg:text-[13px] text-white border-t-steel border-b-graphite border-b border-t-2 bg-graphite'><strong>가입일자</strong></th>
                    </tr>
                    {directReferals.map((item, index) => (
                        <tr key={item.id}>
                            <td align="center" className="hidden lg:table-cell text-xs lg:text-sm border-b">{(currentPage - 1) * pageSize + index + 1}</td>
                            <td align="center" className="text-xs lg:text-sm border-b">{item.username}</td>
                            <td align="center" className="text-xs lg:text-sm border-b">{item.nickname || '-'}</td>
                            <td align="center" className="text-xs lg:text-sm border-b">{item.name || '-'}</td>
                            <td align="center" className="text-xs lg:text-sm border-b">
                                {item.created_at ? item.created_at.slice(0, 10) : '-'}
                                {/* Alternative: new Date(item.created_at).toLocaleDateString('ko-KR') */}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className='mt-1'>
                <PaginationButtons totalPages={totalPages} currentPage={currentPage} onPageChange={handlePageChange} />
            </div>
        </>
    )
}

export default RecommendTable